import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

const COGNITO_CLIENT_ID =
  process.env.VUE_APP_COGNITO_CLIENT_ID || '5doo9h4vqutnrbgani23emmn7n'

window.__WALL_LABS_COGNITO_CLIENT_ID__ = COGNITO_CLIENT_ID

createApp(App)
.use(router)
.use(vuetify)
.mount('#app')